(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ShoretripsBooking',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.shoretrips-booking-new-or-existing').change(function adjustedNewOrExisting() {
			if ($(this).val() === 'new') {
				$(this).parents('p').next().find(".pre-selected-client-typeahead").css('text-decoration', 'line-through');
				$(this).parents('p').next().find(".toggle-client-name").css('visibility', 'hidden');
				$(this).parents('p').next().find(".reset-typeahead").find('a').trigger('click');
				$(this).parents('p').next().find(".existing-client").prop('disabled', true);
			} else {
				$(this).parents('p').next().find(".pre-selected-client-typeahead").css('text-decoration', 'none');
				$(this).parents('p').next().find(".toggle-client-name").css('visibility', 'visible');
				$(this).parents('p').next().find(".existing-client").prop('disabled', false);
			}
		});

		Adzuki.Typeahead(
			'.shoretrips-reservation-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/Reservations/autocomplete/' + term + '/0');
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for reservations."}]);
				});
			},
			function select(item) {
				if (item.id !== null) {
					$('#shoretripsbooking-reservation_id').val(item.id);
				}
			}
		);

		if ($('#shoretripsbooking-has_existing').val() === '1') {
			$('#shoretripsbooking-reservation_lookup').prop('disabled', true);
		}

		$('.other-reservation').click(function otherReservationClicked() {
			$('#shoretripsbooking-reservation_lookup').prop('disabled', false);
			$('#shoretripsbooking-reservation_lookup').val('');
			$('#shoretripsbooking-reservation_id').val('');
		});

		$('.existing-reservation').click(function existingReservationClicked() {
			$('#shoretripsbooking-reservation_lookup').prop('disabled', true);
			$('#shoretripsbooking-reservation_id').val('');
			$('#shoretripsbooking-reservation_lookup').val('');
		});

		$('.no-reservation').click(function noReservationClicked() {
			$('#shoretripsbooking-reservation_lookup').prop('disabled', true);
			$('#shoretripsbooking-reservation_id').val('');
			$('#shoretripsbooking-reservation_lookup').val('');
		});
	};

}(jQuery, window.Adzuki || {}));
